import { render } from "./Allergeni.vue?vue&type=template&id=7bfc270c&scoped=true"
import script from "./Allergeni.vue?vue&type=script&lang=js"
export * from "./Allergeni.vue?vue&type=script&lang=js"

import "./Allergeni.vue?vue&type=style&index=0&id=7bfc270c&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfc270c"]])

export default __exports__